<app-mosaic-como-long-push-atom
  *ngIf="!isLoading && !comoUser && (isComoEnabled$ | async)"
  [heading]="heading ? heading : 'como.join-loyalty'"
  [text]="text ? text : 'como.benefit-from-offers'"
  [textColor]="textColor"
  [backgroundColor]="backgroundColor"
  (click)="onClick()"
>
</app-mosaic-como-long-push-atom>
